import login from "assets/images/login.png";
import LoginForm from "./form";
import AppLogo from "components/common/Logo";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import FPForm from "./form";
import SetPasswordForm from "./form";

const SetPassword = () => {
	const mdScreen = useMediaQuery("(min-width:767px)");

	return (
		<div className="flex items-center justify-center bg-gray-100">
			<div className="flex flex-col md:flex-row min-h-screen w-full bg-white relative">
				<Link
					to={"/"}
					className="flex md:absolute justify-center md:top-2 md:left-4 md:ml-8 z-50 mt-2 cursor-pointer"
				>
					<AppLogo mode={mdScreen ? "light" : "dark"} />
				</Link>
				<div className="md:w-1/2 flex justify-center items-center bg-orange-100 m-5 md:m-0">
					<img src={login} alt="Fashion Quote" className="h-full object-fill" />
				</div>

				<SetPasswordForm />
			</div>
		</div>
	);
};

export default SetPassword;
